import { useState } from 'react'

import { ReviewDisplayModal } from './ReviewDisplayModal'
import { ReviewImageThumbnails } from './ReviewImageThumbnails'

interface ReviewImageGalleryProps {
  images: string[]
  reviewText?: string
  reviewRating?: number
  reviewerName?: string
}

export const ReviewImageGallery = ({ images, reviewText, reviewRating, reviewerName }: ReviewImageGalleryProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [_currentImageIndex, setCurrentImageIndex] = useState(0)

  if (!images || images.length === 0) return null

  const openModal = (index: number) => {
    setCurrentImageIndex(index)
    setModalOpen(true)
  }

  return (
    <>
      <ReviewImageThumbnails images={images} onImageClick={openModal} />

      <ReviewDisplayModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        images={images}
        reviewText={reviewText}
        reviewRating={reviewRating}
        reviewerName={reviewerName}
      />
    </>
  )
}
